module.exports = __webpack_public_path__ + "img/13.c7c0a768.png";